import styled from 'styled-components';

import {ellipsis} from '../../../../../../libs/shared/ui/src/styles/mixins';

/*
 * Common styled components used in the Conversation Summary.
 */

export const StyledLoaderDiv = styled.div`
  padding: 3px 0;
`;

export const StyledEmptyDiv = styled.div`
  color: ${(p) => p.theme.greys.shade60};
`;

export const StyledGridContentDiv = styled.div`
  grid-column: 2;
  ${ellipsis()};
`;

export const StyledIconDiv = styled.div`
  grid-column: 1;
  margin-right: 10px;
`;

export const StyledCountSpan = styled.span`
  margin-left: 5px;
  color: ${(p) => p.theme.greys.shade50};
`;
